import { schema } from 'normalizr';

export const skinGlove = new schema.Entity('skinGloves');

export const skinGloveList = new schema.Array(skinGlove);
